<div class="backroundMenu">
  <div class="ml-5 mt-4 mb-6 hidden xl:block">
    <p-image src="assets/images/logo.png" width="200px"></p-image>
  </div>
  <div class="flex flex-column justify-content-between gap-3">
    <div class="flex justify-content-center">
      <p-panelMenu [model]="sidebarMenu"></p-panelMenu>
    </div>
    @if(multiLingua){
      <div class="flex justify-content-center gap-3 mb-4">
        @for(lang of languageOptions; track $index){
          @if(lang.enabled){
            <i class="cursor-pointer" [class]="lang.icon" (click)="switchLanguage(lang.value)"></i>
          }
        }
      </div>
    }
  </div>
</div>
